import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { handleSignOut } from 'lib/utils/amplify';
import { validateJWT } from 'lib/utils';
import { logout } from 'lib/actions';
import { refreshToken } from 'utils/auth';
import jwtDecode from 'jwt-decode';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAccountActivationRequired } from '../../../../hooks';
import {
    PAYMENT_MAKE_PAYMENT,
    PAYMENT_SEND_PAYMENT,
    PAYMENT_STANDING_ORDER,
} from '../../../../constants/shared/routes';

const forbiddenRoutesForReadOnly = [
    PAYMENT_MAKE_PAYMENT,
    PAYMENT_SEND_PAYMENT,
    PAYMENT_STANDING_ORDER,
];

const WithAuth = ProtectedComponent => {
    const storedToken = localStorage.getItem('accessToken');
    const isAuthorized = validateJWT(storedToken);
    const isAccountActivationRequired = useIsAccountActivationRequired();
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    const handleLogout = () => {
        dispatch(logout());
        handleSignOut();
    };

    useEffect(() => {
        if (!storedToken) return;
        try {
            const { exp } = jwtDecode(storedToken);
            const now = Date.now();
            const expirationTime = exp * 1000;
            const refreshBefore = 60 * 1000;
            const timeUntilRefresh = Math.max(
                expirationTime - now - refreshBefore,
                0,
            );

            const timeoutId = setTimeout(() => {
                refreshToken(dispatch);
            }, timeUntilRefresh);

            return () => clearInterval(timeoutId);
        } catch (err) {
            console.log('Invalid token:', err);
            dispatch(logout());
        }
    }, [dispatch, storedToken]);

    if (!isAuthorized) {
        handleLogout();
        return <Navigate to="/auth" />;
    }

    if (
        isAccountActivationRequired &&
        forbiddenRoutesForReadOnly.includes(pathname)
    ) {
        return <Navigate to="/" />;
    }

    return ProtectedComponent.children;
};

export default WithAuth;
